import buildResourceActions from 'store/configure/actions';

const resourceActions = buildResourceActions('sharedVideosV2');

export default resourceActions;
